/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Form, FormGroup, Label, Input, Row, Col } from 'reactstrap'

class TrueOrFalseKeywordValue extends React.Component
{

  constructor(props)
  {
    super();

    this.handleClick = this.handleClick.bind(this);
  }
  
  handleClick(event)
  {
    this.props.setSaveButtonDisabled(false);
    this.props.setKeywordValue(event.target.value);
  }

  render()
  {
    return(
      <Form  id="trueOrFalseKeywordValue">
        <Row>
          <Col sm={{size: 2, offset: 1}}>
            <FormGroup check className="form-check-inline">
              <Label check>
                <Input defaultChecked={this.props.trueChecked} type="radio" id="trueRadioButton" name="trueFalseRadio" value="True" onClick={this.handleClick} 
                  autoFocus />
                True
              </Label>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup check className="form-check-inline">
              <Label check>
                <Input defaultChecked={this.props.falseChecked} type="radio" id="falseRadioButton" name="trueFalseRadio" value="False" onClick={this.handleClick} />
                False
              </Label>
            </FormGroup>
          </Col>
        </Row>
      </Form>      
    )
  }
}

export default TrueOrFalseKeywordValue
